module.exports = __webpack_public_path__ + "static/media/internat_151.0ea45883.ico";